import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";

function MainLayout() {
  return (
    <div>
      <Header />
      <main>
        {/* 이 부분에 자식 라우트들이 렌더링됩니다 */}
        <Outlet />
      </main>
    </div>
  );
}

export default MainLayout;
